import { MenuItemIndividualItem } from '../../../atomic/molecules/Dropdown_V2/interfaces';
import { AutocompleteDropdownItem } from '../../../atomic/organism/Autocomplete/interfaces';
import { ModalButtonProps } from '../../../atomic/templates/BasicModalTemplate';

export enum ShareSheetModalScreen {
  HOME = 'home',
  VIEWERS = 'viewers',
  PARTICIPANTS = 'participants',
  ANONYMOUS_SETTINGS = 'anonymousSettings',
  LINK_ACCESS_SETTINGS = 'link_access_settings',
  PREVIEW_ACCESS_SETTINGS = 'preview_access_settings',
}

export enum VisibilityTypes {
  ENTIRE_ORGANIZATION = 'EVERYONE',
  // eslint-disable-next-line max-len
  EVERYONE = 'EVERYONE', // Just a bit of redundancy here in case any instances of .EVERYONE still exist, pretty sure I caught them all but not 100% and don't want to break the flow builder accidentally over a text change. Once we're sure we should delete this option.
  PARTICIPANTS_ONLY = 'PARTICIPANTS_ONLY',
  OWNER_AND_COLLABORATORS_ONLY = 'OWNER_AND_COLLABORATORS_ONLY',
  CUSTOM = 'CUSTOM',
}

export type ShareSheetModalButtonProps = {
  primaryButton: ModalButtonProps;
  secondaryButton: ModalButtonProps;
  headerButton: ModalButtonProps;
};

export enum ShareSheetRuleAccessTypes {
  Simple = 'SIMPLE',
  Advance = 'ADVANCE',
}

export enum SimplifiedShareSheetDataTypes {
  Member = 'member',
  Department = 'department',
  Everyone = 'everyone',
  Channel = 'channel',
  JobTitle = 'jobTitle',
  WorkLocation = 'workLocation',
  HomeLocation = 'homeLocation',
}

// TODO: Sumedha - use typefest to make this more robust
export interface SimplifiedShareSheetCardData
  extends AutocompleteDropdownItem<string> {
  setting?: MenuItemIndividualItem;
  isOwner?: boolean;
  isCollaborator?: boolean;
  type: SimplifiedShareSheetDataTypes;
  condition?: string;
}

export enum ShareSheetModalTabIndex {
  InviteAndShare = 0,
  Connections = 1,
}
